function dm_c_18_locaton_map_list() {
    console.log('>> c-18-location-map-list');

    const sections = document.querySelectorAll('section.c-18-location-map-list');
    if (!sections.length) return;

    sections.forEach((section) => {
        const buttons = Array.from(section.querySelectorAll('.content-switch .option'));
        const mapRow  = section.querySelector('.c-18-map');
        const listRow = section.querySelector('.c-18-list');
        if (!buttons.length || !mapRow || !listRow) return;

        function setView(view){
            const isMap = view === 'map';
            mapRow.hidden  = !isMap;
            listRow.hidden = isMap;
            buttons.forEach(b => b.classList.toggle('active', (b.getAttribute('data-switch') || '') === view));
        }

        buttons.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const val = btn.getAttribute('data-switch') || 'list';
                setView(val);
            });
        });

        // init to current active or default to list
        const active = buttons.find(b => b.classList.contains('active'));
        setView((active && active.getAttribute('data-switch')) || 'list');

    });



    // If URL contains ?oid=<int> scroll to the section that contains #office-<id>
    function handleOidScroll() {
        try {
            const params = new URLSearchParams(window.location.search);
            const oid = params.get('oid');
            if (!oid) return;
            const id = parseInt(oid, 10);
            if (!Number.isFinite(id)) return;

            const officeEl = document.getElementById('office-' + id);
            if (!officeEl) return;

            // Find the closest module section
            const sectionEl = officeEl.closest('section.c-18-location-map-list') || officeEl.closest('section');
            if (!sectionEl) return;

            // Scroll instantly (no animation), account for fixed header offset
            const offset = 50;
            const top = Math.round(sectionEl.getBoundingClientRect().top + window.pageYOffset - offset);
            window.scrollTo(0, top);

            // optional visual hint on the card
            officeEl.classList.add('dm-oid-highlight');
            setTimeout(() => officeEl.classList.remove('dm-oid-highlight'), 2200);
        } catch (err) {
            // fail silently in production, useful during debugging
            console.error('handleOidScroll', err);
        }
    }

    // run after a tick to ensure any other init has completed
    setTimeout(handleOidScroll, 40);

}

export { dm_c_18_locaton_map_list };